// Behance.js
import React, { useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import LanguageModal from "./LanguageModal";

const Behance = () => {
  const [showModal, setShowModal] = useState(false);

  const links = {
    es: "https://www.behance.net/mdcvisual",
  };

  return (
    <>
      {/* biome-ignore lint/a11y/useButtonType: <explanation> */}
      <button
        className="button-styles hover-text"
        onClick={() => setShowModal(true)}
      >
        <span className="tooltip-text fade">Behance</span>
        <Icon icon="bi:behance" />
      </button>
      {showModal && (
        <LanguageModal
          title="Behance"
          icon="bi:behance"
          links={links}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default Behance;
